//@flow

import React, { Component, Fragment } from 'react';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { withRouter } from 'react-router-dom';

import type { TrekData } from '../../../types/cards';

import { fetchChildTreks } from '../../../redux/actions/selectedTrekActions';

type Props = {
  trekId: string,
  region: string,
  treks: TrekData | null,
  authors: {
    fullname: string | null,
    profileImage: string | null,
  } | null,
  fetchFixDepartures: () => void,
};

const mapStateToProps = ({ selectedTrek: { childTreks } }) => ({
  treks: (childTreks && childTreks.treks) || null,
  authors: (childTreks && childTreks.authors) || null,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchFixDepartures: () => dispatch(fetchChildTreks(ownProps.match.params.trekId)),
});

class FixDeparture extends Component<Props> {
  async componentDidMount() {
    await this.props.fetchFixDepartures();
  }

  render() {
    const { treks } = this.props;

    return (
      <Fragment>
        {!isEmpty(treks) && (
          <div className="white-panel">
            <div className="onboard-action mt-3">
              <h5>Would you like to talk to HoneyGuide?</h5>
              <a href="https://wa.me/9779801916215" target="_blank" rel="noopener noreferrer">
                <Button color="yellow" size="sm">
                  Message us
                </Button>
              </a>
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(FixDeparture)
);



// WEBPACK FOOTER //
// ./src/components/TrekDetail/DayOverview/FixDeparture.jsx